import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule,FormsModule }  from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { QRCodeModule } from 'angular2-qrcode';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FooterHelpdeskComponent } from './footer-helpdesk/footer-helpdesk.component';
import { DealRegistrationComponent } from './deal-registration/deal-registration.component';
import { ReferralComponent } from './referral/referral.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { ProfileDetailsComponent } from './profile-details/profile-details.component';
import { CreditNoteComponent } from './credit-note/credit-note.component';
import { PrepaidNoteComponent } from './prepaid-note/prepaid-note.component';
import { LicenseComponent } from './license/license.component';
import { LeadsComponent } from './leads/leads.component';
import { ResellerPriceListComponent,SafePipe  } from './reseller-price-list/reseller-price-list.component';
import { CallHistoryComponent } from './call-history/call-history.component';
import { Buy3cxComponent } from './buy3cx/buy3cx.component';
import { SupportTicketComponent } from './support-ticket/support-ticket.component';
import { SupportTicketListComponent } from './support-ticket-list/support-ticket-list.component';
import { SupportTicketListThreadComponent } from './support-ticket-list-thread/support-ticket-list-thread.component';
import { SupportTicketDashboardComponent } from './support-ticket-dashboard/support-ticket-dashboard.component';
import { DealRegisterFormComponent } from './deal-register-form/deal-register-form.component';
import { SupportTicketThreadComponent } from './support-ticket-thread/support-ticket-thread.component';
import { LoginComponent } from './login/login.component';
import { ForgotPwdComponent } from './forgot-pwd/forgot-pwd.component';
import { ShoppingCartComponent } from './shopping-cart/shopping-cart.component';
import { CmsUserComponent } from './cms-user/cms-user.component';
import { CmsUsernewComponent } from './cms-usernew/cms-usernew.component';
import { ExtensionsComponent } from './extensions/extensions.component';
import { NewextensionComponent } from './newextension/newextension.component';
import { CallhistorypbxComponent } from './callhistorypbx/callhistorypbx.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as GoQrcode from "go-qrcode";
import { DragDropDirective } from './drag-drop.directive';
import { ReadmoreComponent } from './readmore/readmore.component';
import {RoundProgressModule} from 'angular-svg-round-progressbar';
import { ShoppingcartdetailsComponent } from './shoppingcartdetails/shoppingcartdetails.component';
import { RenewalComponent } from './renewal/renewal.component';
import { GccComponent } from './gcc/gcc.component';
import { CallhistoryvspbxComponent } from './callhistoryvspbx/callhistoryvspbx.component';
import { NotificationComponent } from './notification/notification.component';
import { CostcenterComponent } from './costcenter/costcenter.component';
import { CostcentereditComponent } from './costcenteredit/costcenteredit.component';
import { IddpricelistComponent } from './iddpricelist/iddpricelist.component';
import { PaysuccessComponent } from './paysuccess/paysuccess.component';
import { HelpvideosComponent } from './helpvideos/helpvideos.component';
// import {Pipe,PipeTransform} from "@angular/core";
// import { SafePipeModule } from 'safe-pipe';

import { CheckpageComponent } from './checkpage/checkpage.component';
import { LogincmsComponent } from './logincms/logincms.component';
import { OcbcSuccessComponent } from './ocbc-success/ocbc-success.component';
import { AllowWhitelistComponent } from './allow-whitelist/allow-whitelist.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatChipsModule} from '@angular/material/chips';
import {MatInputModule} from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import { CreditsPaymentComponent } from './credits-payment/credits-payment.component';
import { PaysuccessTopupComponent } from './paysuccess-topup/paysuccess-topup.component';
import { BuyCreditsComponent } from './buy-credits/buy-credits.component';
import { ContactgroupComponent } from './contactgroup/contactgroup.component';
import { ContactGroupEditComponent } from './contact-group-edit/contact-group-edit.component';
import { CalleridlistComponent } from './calleridlist/calleridlist.component';
import { BizFileUploadComponent } from './biz-file-upload/biz-file-upload.component';
// import  {  PdfViewerModule  }  from  'ng2-pdf-viewer';
@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    FooterComponent,
    DashboardComponent,
    FooterHelpdeskComponent,
    DealRegistrationComponent,
    ReferralComponent,
    InvoiceComponent,
    ProfileDetailsComponent,
    CreditNoteComponent,
    PrepaidNoteComponent,
    LicenseComponent,
    LeadsComponent,
    ResellerPriceListComponent,
    SafePipe,
    CallHistoryComponent,
    Buy3cxComponent,
    SupportTicketComponent,
    SupportTicketListComponent,
    SupportTicketListThreadComponent,
    SupportTicketDashboardComponent,
    DealRegisterFormComponent,
    SupportTicketThreadComponent,
    LoginComponent,
    ForgotPwdComponent,
    ShoppingCartComponent,
    CmsUserComponent,
    CmsUsernewComponent,
    ExtensionsComponent,
    NewextensionComponent,
    CallhistorypbxComponent,
    DragDropDirective,
    ReadmoreComponent,
    ShoppingcartdetailsComponent,
    RenewalComponent,
    GccComponent,
    CallhistoryvspbxComponent,
    NotificationComponent,
    CostcenterComponent,
    CostcentereditComponent,
    IddpricelistComponent,
    PaysuccessComponent,
    HelpvideosComponent,
    CheckpageComponent,
    LogincmsComponent,
    OcbcSuccessComponent,
    AllowWhitelistComponent,
    CreditsPaymentComponent,
    PaysuccessTopupComponent,
    BuyCreditsComponent,
    ContactgroupComponent,
    ContactGroupEditComponent,
    CalleridlistComponent,
    BizFileUploadComponent,
       // SafePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
     ReactiveFormsModule,
     HttpClientModule,
    FormsModule,
    QRCodeModule,
    EditorModule,
    RoundProgressModule,
    BrowserAnimationsModule,
    MatChipsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatIconModule
    // SafePipe
    // SafePipeModule ,
      // PdfViewerModule
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
